/* tslint:disable */

declare var Object: any;
export interface WorkLocationInterface {
  "id"?: number;
}

export class WorkLocation implements WorkLocationInterface {
  "id": number;
  constructor(data?: WorkLocationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WorkLocation`.
   */
  public static getModelName() {
    return "WorkLocation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WorkLocation for dynamic purposes.
  **/
  public static factory(data: WorkLocationInterface): WorkLocation{
    return new WorkLocation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WorkLocation',
      plural: 'WorkLocations',
      path: 'WorkLocations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/WorkLocation.ts